// extracted by mini-css-extract-plugin
module.exports = {"scrollable":"PlanUpgradeWizard_scrollable__2bO4C","planUpgradeWizard":"PlanUpgradeWizard_planUpgradeWizard__3NBNw","wizardCard":"PlanUpgradeWizard_wizardCard__boAWr"};